import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

  constructor(public rest: RestService) { }

  public findBySuiteId(id: string, db: number):Observable<any>{
    if(db==2) {
      return this.rest.get('getSuiteParameterDb2', id);
    }
    return this.rest.get('getSuiteParameter', id);
  }

  public findByFeatureId(id: string):Observable<any>{
    return this.rest.get('getFeatureParameter', id);
  }

  public findByScenarioId(id: string):Observable<any>{
    return this.rest.get('getScenarioParameter', id);
  }
  
}